<template>
	<Modal :closeButton="closeButton" :title="title" @close="close()" :zIndex="118">
		<template v-slot:content>
			<div :class="{ content_narrow: narrowMode, content: !narrowMode }">
				<slot name="content"></slot>
				<div>{{ text }}</div>
			</div>
		</template>
		<template v-slot:footer>
			<div :class="{ buttons: !narrowMode, buttons_narrow: narrowMode }">
				<button v-if="leftButtonText !== ''" @click="leftButtonAction()" :disabled="leftButtonDisable" class="button-blank-color roundButton">
					{{ leftButtonText }}
				</button>
				<button v-if="rightButtonText !== ''" @click="rightButtonAction()" :disabled="rightButtonDisable" class="button-primary-color roundButton">
					{{ rightButtonText }}
				</button>
			</div>
		</template>
	</Modal>
</template>

<script>
	import Modal from '../Modal';

	export default {
		name: 'DualButtonModal',
		components: { Modal },
		props: {
			text: String,
			title: String,
			leftButtonText: String,
			rightButtonText: String,
			leftButtonAction: Function,
			rightButtonAction: Function,
			rightButtonDisable: Boolean,
			leftButtonDisable: Boolean,
			closeButton: Boolean,
			narrowMode: Boolean
		},
		methods: {
			close() {
				this.$emit('close');
			}
		}
	};
</script>

<style lang="scss" scoped>
	.content {
		text-align: center;
		padding: var(--step-5);
		display: flex;
		/*height: 100%;*/
		align-items: center;
		justify-content: center;
	}
	.content_narrow {
		text-align: left;
		padding: var(--step-5);
		display: flex;
		/*height: 100%;*/
		align-items: center;
		justify-content: center;
	}

	.buttons {
		display: flex;
		justify-content: space-evenly;
		width: 100%;
		min-width: 45vw;

		button {
			font-size: var(--step--1);
			min-width: 150px;
			min-height: 45px;
			width: 10vw;
			height: 2.5vw;
			border-radius: 72px;
		}

		padding-bottom: calc(var(--step-5) / 2);
	}
	.buttons_narrow {
		display: flex;
		justify-content: center;
		width: 100%;
		min-width: 45vw;
		gap: 2rem;

		button {
			font-size: var(--step--1);
			min-width: 150px;
			min-height: 45px;
			width: 12vw;
			height: 2.5vw;
			border-radius: 72px;
		}
		padding-bottom: calc(var(--step-5) / 2);
	}
</style>
